import { defineMessages } from 'react-intl';

export default defineMessages({
    covMiscellaneous: {
        id: 'quoteandbind.PLEEveLiaLinedirectives.templates.Miscellaneous.Coverages',
        defaultMessage: 'Coverages'
    },
    formMiscellaneous:{
        id: 'quoteandbind.PLEEveLiaLinedirectives.templates.Miscellaneous.Endorsements',
        defaultMessage: 'Endorsements'
    }
});